import { render, staticRenderFns } from "./device_category.vue?vue&type=template&id=bc7464b2&scoped=true&"
import script from "./device_category.vue?vue&type=script&lang=js&"
export * from "./device_category.vue?vue&type=script&lang=js&"
import style0 from "./device_category.vue?vue&type=style&index=0&id=bc7464b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7464b2",
  null
  
)

export default component.exports